<template>
	<v-dialog v-model="dialog" max-width="700px" persistent>
		<DialogPersonalizado titulo="Configurações" icone="mdi-cog-outline" @dialogClose="dialogClose">
			<v-row align="center" v-if="loading" justify="center" class="pa-4">
				<v-progress-linear color="primary" indeterminate />
			</v-row>
			<v-row>
				<v-col class="ma-0 pa-0">
					<p><b>Exibir observação da empresa?</b></p>
					<v-radio-group
						class="ma-0 pa-0"
						v-model="configuracoes.observacaoEmpresa"
						hide-details
						:disabled="loading"
					>
						<v-radio label="Desabilitado" value=" " />
						<v-radio label="Exibe observação" value="O" />
						<v-radio
							label="Exibe observação e exibe a referência (referência junto com o código do produto)"
							value="R"
						/>
					</v-radio-group>
				</v-col>
				<v-divider vertical class="ml-2 mr-4"/>
				<v-col class="ma-0 pa-0">
					<p><b>Quais códigos exibir?</b></p>
					<v-checkbox v-model="configuracoes.codigos" label="Código (Pro_codigo)" value=" " hide-details class="mt-0 pt-0"></v-checkbox>
					<v-checkbox v-model="configuracoes.codigos" label="Código 1 (Pro_codigo1)" value="1" hide-details></v-checkbox>
					<v-checkbox v-model="configuracoes.codigos" label="Código 2 (Pro_codigo2)" value="2" hide-details></v-checkbox>
					
				</v-col>
			</v-row>
			<v-btn class="white--text mt-8" @click="salvar()" color="#CC2128" large width="100%"> Salvar </v-btn>
		</DialogPersonalizado>
	</v-dialog>
</template>

<script>
import DialogPersonalizado from '../shared/dialogPersonalizado.vue'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'

export default {
	props: {
		abrirDialog: Boolean,
		id: String,
	},
	components: {
		DialogPersonalizado,
	},
	data() {
		return {
			empresa: {},
			mascaraCpfCnpj: '',
			mascaraTelefone: '',
			configuracoes: {},
			loading: false,
		}
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster']),
		...mapState('usuarios', ['usuario', 'dialog']),
		dialog: {
			get() {
				return this.abrirDialog
			},
			set() {
				this.dialogClose()
			},
		},
	},
	methods: {
		...mapMutations('usuarios', ['setDialog']),
		...mapActions('usuarios', ['hideDialog']),

		dialogClose() {
			this.configuracoes = {}
			this.$emit('dialogClose')
		},
		async loadConfiguracoes() {
			try {
				this.loading = true

				const response = await this.axios.get(`/empresas/${this.id}/configuracoes`)
				this.configuracoes = response.data
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		async salvar() {
			try {
				this.loading = true

				const response = await this.axios.put(`/empresas/${this.id}/configuracoes`, {
					observacaoEmpresa: this.configuracoes.observacaoEmpresa,
					codigos: this.configuracoes.codigos,
				})
				if (response.status == 204) {
					//this.fecharTab()
					this.dialogClose()
					this.$store.dispatch('showSuccess', 'Configurações salvas com sucesso!')
				}
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
	},
	watch: {
		abrirDialog() {
			if (this.abrirDialog) this.loadConfiguracoes()
		},
	},
}
</script>
